import type { ReactNode } from "react";
import Breadcrumbs from "@/components/base/Breadcrumbs";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description?: string;
  breadcrumbs: { label: string; to?: string }[];
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, description, breadcrumbs, children }: PageHeroProps) {
  return (
    <section className="relative w-full overflow-hidden bg-primary-950 px-4 py-10 md:px-10 md:py-14">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl" />
      <div className="pointer-events-none absolute right-10 top-1/2 hidden h-40 w-40 -translate-y-1/2 items-center justify-center text-background-50/5 lg:flex">
        <i className="ri-film-line text-[9rem]" />
      </div>

      <div className="relative z-10">
        <div className="[&_a]:text-background-300 [&_a:hover]:text-accent-400 [&_span]:text-background-400">
          <Breadcrumbs items={breadcrumbs} />
        </div>

        {eyebrow && (
          <span className="mt-5 block font-label text-[11px] uppercase tracking-[0.3em] text-accent-400">
            {eyebrow}
          </span>
        )}
        <h1 className="mt-2 font-heading text-2xl font-semibold text-background-50 md:text-4xl">{title}</h1>
        {description && (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-300">{description}</p>
        )}
        {children && <div className="mt-6 max-w-xl">{children}</div>}
      </div>
    </section>
  );
}